export * from "-!../../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fr.vue?vue&type=template&id=76b8b56e"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/fr.vue?vue&type=template&id=76b8b56e
// module id = KaRn
// module chunks = 0